import React from 'react'
import axios from 'axios'

class Bios extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: [],
			nextShowId: null
		}
	}

	componentDidMount(){
		this.fetchNextShowId()
	}

	fetchData(){
		axios.get('//dhsetheatre-api.madebypeppernet.com/api-admin.php', {
			params: {
				filename: 'bios'
			}
		}).then( response => {
			// Filter the bios to just the next upcoming show.
			let data = response.data.items.filter( bio => bio.show_id === this.state.nextShowId )
			this.setState({
				items: data.sort( (a, b) => {
					let nameA = a.lastname.toLowerCase(), nameB = b.lastname.toLowerCase()
					if(nameA < nameB)
						return -1
					if(nameA > nameB)
						return 1
					return 0
				})
			})
		})
	}

	fetchNextShowId(){
		axios.get('https://dhsetheatre-api.madebypeppernet.com/api-admin.php', {
			params: {
				filename: 'shows'
			}
		}).then( response => {
			this.setState({
				nextShowId: response.data.items.filter( show => show.isHero )[0].id
			})
		})
		.then( () => this.fetchData() )
	}

	render() {
		return (
			<section className="container cast bios">
				<h2>Meet the Cast</h2>
				{
					this.state.items.map( (item, index) => {
						return (
							<div key={index} className="dynamic row">
								<div className="col_4">
									{
										item.head_shot ?
											<img src={item.head_shot} alt={item.name} /> :
											/*<img src="./images/default_avatar.jpg" alt={item.name} />*/ null
									}
								</div>
								<div className="col_8">
									<p><strong>{decodeURIComponent(item.firstname) + ' ' + decodeURIComponent(item.lastname)}</strong> - {decodeURIComponent(item.part)}</p>
									<p>{decodeURIComponent(item.bio)}</p>
								</div>
							</div>
						)
					})
				}
			</section>
		)
	}
}

export default Bios



// WEBPACK FOOTER //
// ./src/pages/bios.js